module.exports = __webpack_public_path__ + "img/trade-img-8coin.a2b5fe81.png";